module.exports = "<span class=\"_card\"></span>\r\n\r\n<!--<bws-product product=\"card.data.product\" product-collection=\"\"></bws-product>-->"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/cards/card-template.html
 ** module id = 894
 ** module chunks = 1
 **/